import React from 'react'

export default function EditSmall(props) {
  return (
    <svg
      width={16}
      height={16}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.26429 3.74232H3.92716C2.82132 3.74232 1.92487 4.63878 1.92487 5.74462V12.4189C1.92487 13.5247 2.82132 14.4212 3.92716 14.4212H10.6015C11.7073 14.4212 12.6037 13.5247 12.6037 12.4189V5.74461C12.6037 5.74174 12.6037 5.73887 12.6037 5.736V9.08176H11.6026V12.4189C11.6026 12.9718 11.1544 13.4201 10.6015 13.4201H3.92716C3.37424 13.4201 2.92601 12.9718 2.92601 12.4189V5.74462C2.92601 5.1917 3.37424 4.74347 3.92716 4.74347H7.26429V3.74232Z'
        fill='currentColor'
      />
      <path d='M8.85589 6.79736L12.7785 2.87472' stroke='currentColor' strokeWidth={1.66857} />
      <path
        d='M9.21853 7.62467L8.04422 6.45036L7.57685 8.08001L9.21853 7.62467Z'
        fill='currentColor'
      />
      <rect
        x={12.8984}
        y={1.57877}
        width={1.66405}
        height={0.667778}
        transform='rotate(45 12.8984 1.57877)'
        fill='currentColor'
      />
    </svg>
  )
}
